import { useParams } from "react-router";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "@refinedev/react-hook-form";

import { useEditAgreementMutation } from "@modules/agreements/services/mutations";
import {
  AgreementFormValues,
  agreementSchema,
} from "@modules/agreements/validations/agreementSchema";
import { isValidCNPJ } from "@modules/agreements/utils/isValidCNPJ";
import { useNotification, useTranslate } from "@refinedev/core";
import { SubmitHandler, SubmitErrorHandler } from "react-hook-form";

export function useAgreementEditForm() {
  const { id } = useParams();
  const translate = useTranslate();

  const { open } = useNotification();

  const { mutateAsync, isPending } = useEditAgreementMutation(id as string);

  const methods = useForm<AgreementFormValues>({
    resolver: zodResolver(
      agreementSchema({
        cnpj: {
          validate: async (value) => isValidCNPJ(value),
          errorMessage: translate("v1/agreement_admin.errors.invalidCNPJ"),
        },
        volumetryEmailDay: translate("v1/agreement_admin.errors.volumetryEmailDay"),
        invalidEmail: translate("v1/agreement_admin.errors.invalidEmail"),
      })
    ),
    mode: "onBlur",
  });

  const {
    handleSubmit,
    refineCore: { formLoading },
  } = methods;

  const onError: SubmitErrorHandler<AgreementFormValues> = (errors) => {
    open?.({
      type: "error",
      message:
        "Verifique os campos obrigatórios se tiver abas verifique em todas as abas",
    });
  };

  return {
    methods,
    handleSubmit: () =>
      handleSubmit((data) => mutateAsync(data as any), onError),
    isPending,
    formLoading,
    id,
  };
}
